"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiFormGroupOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            ".MuiFormLabel-root + &": {
                marginTop: spacing(2),
            },
        },
    });
};
//# sourceMappingURL=MuiFormGroup.js.map